import { CSS, StyleProps } from "@shared/primitive-components"

export const valueContainer = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(2),
})

export const score =
  (value: number | null) =>
  ({ theme }: StyleProps): CSS => {
    const color = value !== null ? `inherit` : theme.palette.grey.dark
    return {
      color,
      fontSize: `90px`,
      lineHeight: `65px`,
    }
  }
